var _path, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-36 -24 72 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-36-24h72v48h-72z",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-56.3099325)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M-6-26H6v2H-6zm0 3H6v2H-6zm0 3H6v2H-6z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    y: 44
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M0,17v10"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cd2e3a",
    d: "M0-12A12 12 0 0 1 0 12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0047a0",
    d: "M0-12A12 12 0 0 0 0 12 6 6 0 0 0 0 0z"
  }), /*#__PURE__*/React.createElement("circle", {
    cy: -6,
    fill: "#cd2e3a",
    r: 6
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-123.6900675)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M0-23.5v3M0,17v3.5M0,23.5v3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKo);
export default __webpack_public_path__ + "static/media/ko.93c7282fba6f136a2b6fd7413abc4b2b.svg";
export { ForwardRef as ReactComponent };